import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { TRouteAuthWrapperProps } from '../types';

/**
 * Private route wrapper. Use `redirectTo` for redirect if isAuthSuccess are true
 */
function RoutePrivate({
  isAuthSuccess,
  redirectTo,
  component: Component,
  title,
  exact,
}: TRouteAuthWrapperProps) {
  return (
    <Route
      exact={exact}
      render={({ history, location, match, staticContext }) =>
        isAuthSuccess ? (
          <Redirect to={redirectTo} />
        ) : (
          <Component
            history={history}
            location={location}
            match={match}
            staticContext={staticContext}
            title={title}
          />
        )
      }
    />
  );
}

export default RoutePrivate;
